var _effectorFileName = "/src/shared/components/modal/modal.tsx";
import { useState } from 'react';
import { EntryPoint } from '@/shared/components/contact-form/types';
import CheckMarkIcon from '@/shared/components/icons/checkmark-icon';
import { TextGradient } from '@/shared/components/text-gradient';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/shared/components/ui/dialog';
interface ModalProps {
  dialogTrigger: React.ReactNode;
  children: React.ReactNode;
  isModalSentSuccessfully: boolean;
  entryPoint: EntryPoint;
  title: string;
  description?: string;
  onModalClosed: () => void;
}
export const Modal = (props: ModalProps) => {
  const {
    dialogTrigger,
    children,
    title,
    description,
    isModalSentSuccessfully,
    onModalClosed
  } = props;
  const [open, setOpen] = useState(false);
  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
    if (!isOpen) {
      onModalClosed();
    }
  };
  return <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>{dialogTrigger}</DialogTrigger>

      <DialogContent className="min-h-[400px] max-w-[90%] rounded-md bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sm:max-w-[425px]">
        {!isModalSentSuccessfully && <>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              {description && <DialogDescription>{description}</DialogDescription>}
            </DialogHeader>

            {children}
          </>}

        {isModalSentSuccessfully && <>
            <DialogHeader className="sr-only">
              <DialogTitle className="sr-only">Заявка отправлена</DialogTitle>
              <DialogDescription className="sr-only">Скоро мы вам напишем</DialogDescription>
            </DialogHeader>

            <div className="flex h-full flex-col items-center justify-center">
              <CheckMarkIcon className="mb-4 h-10 w-10 shrink-0 rounded-full bg-brand-accent-light p-[2px] text-white dark:bg-brand-accent-normal" />

              <div className="text-center">
                <TextGradient text="Заявка отправлена!" className="mb-1 header-h1" />
                <p className="text-muted-foreground">Скоро мы вам напишем</p>
              </div>
            </div>
          </>}
      </DialogContent>
    </Dialog>;
};